export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    d: 768,
    md: 1000,
    lg: 1200,
    xl: 4000,
  },
}
